var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapSalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02442 10.436C0.633 11.8274 0.633 14.0836 2.02442 15.475C3.41584 16.8664 5.67202 16.8664 7.06344 15.475L2.02442 10.436Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39821 9.15246L8.3475 14.1017C8.71446 14.4687 8.71446 15.0637 8.3475 15.4307C7.98055 15.7976 7.38553 15.7976 7.01858 15.4307L2.06929 10.4808C1.70234 10.1139 1.70234 9.51887 2.06929 9.15192C2.43624 8.78497 3.03126 8.78497 3.39821 9.15192V9.15246Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4144 1.92297L15.577 5.08558C16.6229 6.13141 16.5369 7.85186 15.3917 8.7882L8.59321 14.3475L3.15251 8.90677L8.71179 2.10831C9.64812 0.963125 11.3686 0.87713 12.4144 1.92297Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11719 3.91905C9.74266 3.15417 10.8921 3.09648 11.5913 3.79513",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53005 14.7844C4.61658 14.6978 4.75705 14.6978 4.84358 14.7844C4.93011 14.8709 4.93011 15.0114 4.84358 15.0979C4.75705 15.1844 4.61658 15.1844 4.53005 15.0979C4.44352 15.0114 4.44352 14.8709 4.53005 14.7844Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8582 14.3282C2.94473 14.2417 3.08521 14.2417 3.17174 14.3282C3.25827 14.4147 3.25827 14.5552 3.17174 14.6417C3.08521 14.7283 2.94473 14.7283 2.8582 14.6417C2.77167 14.5552 2.77167 14.4147 2.8582 14.3282Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40152 12.6558C2.48805 12.5693 2.62853 12.5693 2.71506 12.6558C2.80159 12.7424 2.80159 12.8828 2.71506 12.9694C2.62853 13.0559 2.48805 13.0559 2.40152 12.9694C2.31499 12.8828 2.31499 12.7424 2.40152 12.6558Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.755851 16.5839C0.84238 16.4974 0.982858 16.4974 1.06939 16.5839C1.15592 16.6705 1.15592 16.8109 1.06939 16.8975C0.982858 16.984 0.84238 16.984 0.755851 16.8975C0.669321 16.8109 0.669321 16.6705 0.755851 16.5839Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18039 17.9069C2.26692 17.8204 2.40739 17.8204 2.49392 17.9069C2.58045 17.9935 2.58045 18.1339 2.49392 18.2205C2.40739 18.307 2.26692 18.307 2.18039 18.2205C2.09386 18.1339 2.09386 17.9935 2.18039 17.9069V17.9069Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60439 19.2294C3.69092 19.1429 3.8314 19.1429 3.91793 19.2294C4.00446 19.316 4.00446 19.4565 3.91793 19.543C3.8314 19.6295 3.69092 19.6295 3.60439 19.543C3.51786 19.4565 3.51786 19.316 3.60439 19.2294Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.755851 19.2294C0.84238 19.1429 0.982858 19.1429 1.06939 19.2294C1.15592 19.316 1.15592 19.4565 1.06939 19.543C0.982858 19.6295 0.84238 19.6295 0.755851 19.543C0.669321 19.4565 0.669321 19.316 0.755851 19.2294Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18039 20.5525C2.26692 20.466 2.40739 20.466 2.49392 20.5525C2.58045 20.639 2.58045 20.7795 2.49392 20.866C2.40739 20.9526 2.26692 20.9526 2.18039 20.866C2.09386 20.7795 2.09386 20.639 2.18039 20.5525V20.5525Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.977516 21.663C1.06405 21.5765 1.20452 21.5765 1.29105 21.663C1.37758 21.7495 1.37758 21.89 1.29105 21.9765C1.20452 22.063 1.06405 22.063 0.977516 21.9765C0.890986 21.89 0.890986 21.7495 0.977516 21.663V21.663Z",
    stroke: "#1D1F20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapSalt);
export default __webpack_public_path__ + "static/media/swap-salt.e0c8818c8449ba571856d91b061b7cc5.svg";
export { ForwardRef as ReactComponent };